var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertProblem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.682,
    height: 30.682,
    viewBox: "0 0 30.682 30.682",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "alert-circle-outline",
    transform: "translate(-4.75 -4.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14677",
    "data-name": "Path 14677",
    d: "M34.182,20.091A14.091,14.091,0,1,0,20.091,34.182,14.094,14.094,0,0,0,34.182,20.091Z",
    fill: "none",
    stroke: "#ea4136",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14678",
    "data-name": "Path 14678",
    d: "M23.462,15.445l.421,8.95.421-8.95a.421.421,0,0,0-.425-.44h0a.421.421,0,0,0-.417.44Z",
    transform: "translate(-3.792 -1.956)",
    fill: "none",
    stroke: "#ea4136",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14679",
    "data-name": "Path 14679",
    d: "M23.593,33.677a1.468,1.468,0,1,1,1.468-1.468A1.468,1.468,0,0,1,23.593,33.677Z",
    transform: "translate(-3.502 -5.373)",
    fill: "#ea4136"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertProblem);
export default __webpack_public_path__ + "static/media/alert-problem.e8a9cb69a322898bdc25b68f902586c5.svg";
export { ForwardRef as ReactComponent };